import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  Grid,
  Label
} from 'semantic-ui-react'

import { PAGES } from '_constants'
import { escapeRE } from '_utils'

import Gravatar from '_views/gravatar'
import UserInfo from '_views/userInfo'
import LicenseItem from '_views/license'
import SuggestionItem from '_views/suggestionItem'
import SuggestionItems from '_views/suggestionItems'
import searchHOC from './searchHOC'

const formatSelection = license => {
  const _id = R.prop('_id', license)
  const name = R.path(['activated_info', 'fastspring', 'name'], license) || `${R.prop('name', license)} ${R.prop('type', license)}`
  const email = R.path(['user', 'email'], license)
  const fullName = R.path(['user', 'full_name'], license)
  return (
    <Label style={{display: 'inline-block'}} key={'sel_' + _id}>
      <div>{ name }</div>
      { email ? <div>{ email }</div> : null }
      { fullName ? <div>{ fullName }</div> : null }
      <div><small>{ _id }</small></div>
    </Label>
  )
}

const getUserDisplay = R.path(['user', 'displayname'])
const getUserEmail = R.path(['user', 'email'])
const getUserFullName = R.path(['user', 'full_name'])
// these all need filtering
const getFsRef = R.compose(
  R.split(' '),
  R.defaultTo(''),
  R.path(['activated_info', 'fastspring', 'reference'])
)
const getFsUserRef = R.compose(
  R.split(' '),
  R.defaultTo(''),
  R.path(['activated_info', 'fastspring', 'reference_user'])
)
const getFsSubRef = R.path(['activated_info', 'fastspring', 'subscription', 'reference'])
const getFsFullName = R.path(['activated_info', 'fastspring', 'customer', 'full_name'])
const getFsEmail = R.path(['activated_info', 'fastspring', 'customer', 'email'])
const getFsMax6Sn = R.path(['activated_info', 'fastspring', 'surveys', 'max6_serial'])
const getFsMFLSn = R.path(['activated_info', 'fastspring', 'surveys', 'max4live_serial'])
const getLicSn = R.path(['activated_info', 'serial_id'])
const getAc = R.path(['activated_info', 'ac_id'])
const getId = R.prop('_id')

const formatSuggestion = (license, term) => {
  const name = R.path(['activated_info', 'fastspring', 'name'], license) || `${R.prop('name', license)} ${R.prop('type', license)}`
  const tReg = {
    regex: new RegExp(escapeRE(term), 'i'),
    term
  }
  return (
    <div key={'sug_' + license._id} >
      <SuggestionItem label='license' text={name} tReg={tReg} always={true} />
      <SuggestionItem label='email' text={getUserEmail(license)} tReg={tReg} />
      <SuggestionItem label='display' text={getUserDisplay(license)} tReg={tReg} />
      <SuggestionItem label='name' text={getUserFullName(license)} tReg={tReg} />
      <SuggestionItem label='id' text={getId(license)} tReg={tReg} />

      <SuggestionItems label='fs ref' list={getFsRef(license)} pathFn={R.identity} tReg={tReg} />
      <SuggestionItems label='fs user ref' list={getFsUserRef(license)} pathFn={R.identity} tReg={tReg} />

      <SuggestionItem label='fs sub ref' text={getFsSubRef(license)} tReg={tReg} />
      <SuggestionItem label='fs name' text={getFsFullName(license)} tReg={tReg} />
      <SuggestionItem label='fs email' text={getFsEmail(license)} tReg={tReg} />
      <SuggestionItem label='fs serial' text={getFsMax6Sn(license)} tReg={tReg} />
      <SuggestionItem label='fs MFL serial' text={getFsMFLSn(license)} tReg={tReg} />
      <SuggestionItem label='serial' text={getLicSn(license)} tReg={tReg} />
      <SuggestionItem label='ac' text={getAc(license)} tReg={tReg} />
    </div>
  )
}

const NoEndUser = _ => (
  <Label as='a' image>
    <Gravatar gravatar='wtf' size={20} />
    Unclaimed
  </Label>
)

const License = props => (
  <Grid>
    <Grid.Row>
      <Grid.Column width={3}>
        <UserInfo
          onClick={() => props.setNavigation
            ? props.setNavigation({
              pageName: PAGES.USERS,
              ids: [R.path(['license', 'user', '_id'], props)]
            })
            : null
          }
          user={R.path(['license', 'user'], props)}
          whenNull={<NoEndUser />}
        />
      </Grid.Column>
      <Grid.Column width={13}>
        <LicenseItem {...props} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

License.propTypes = {
  license: PropTypes.object.isRequired,
  // mapDispatchToProps
  onRefreshLicense: PropTypes.func.isRequired,
  onRemoveLicense: PropTypes.func.isRequired,
  onReactivateLicense: PropTypes.func.isRequired,
  onModifyLicense: PropTypes.func.isRequired,
  onRemoveLicenseMachine: PropTypes.func.isRequired,
  onAddSublicense: PropTypes.func.isRequired,
  onRemoveSublicense: PropTypes.func.isRequired,
  setNavigation: PropTypes.func,
  isLoading: PropTypes.bool.isRequired
}

export const { PluralSearch, SingularSearch } = searchHOC({
  icon: 'database',
  placeholder: 'Type to search licenses ...',
  idName: 'licenseId',
  baseSearchUrl: 'licenses',
  formatSelection,
  formatSuggestion
})



// WEBPACK FOOTER //
// ./webAdmin/forms/licenseSearch.js